module.exports = __webpack_public_path__ + "static/gm-19-15251a768d8c8da13b6a0f3bba1e2cf5.jpg";